module.exports = __webpack_public_path__ + "static/media/infant-mortality-rates.35a97562.jpg";